class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.autoCloseTimer = null;
    this.autoCloseDuration = 5000; // 5 секунд

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    // Отменить авто-закрытие при наведении мыши
    this.notification.addEventListener('mouseenter', () => this.pauseAutoClose());
    this.notification.addEventListener('mouseleave', () => this.resumeAutoClose());
  }

  open() {
    this.notification.classList.add('animate', 'active');
    this.notification.classList.remove('closing');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);

    // Запустить авто-закрытие через 5 секунд
    this.startAutoClose();
  }

  close() {
    this.clearAutoClose();
    this.notification.classList.add('closing');
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // Запустить таймер авто-закрытия
  startAutoClose() {
    this.clearAutoClose();
    this.autoCloseTimer = setTimeout(() => {
      this.close();
    }, this.autoCloseDuration);

    // Перезапустить анимацию progress bar
    const progressBar = this.notification.querySelector('.cart-notification__progress-bar');
    if (progressBar) {
      progressBar.style.animation = 'none';
      setTimeout(() => {
        progressBar.style.animation = '';
      }, 10);
    }
  }

  // Остановить таймер авто-закрытия
  clearAutoClose() {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = null;
    }
  }

  // Приостановить авто-закрытие (при наведении мыши)
  pauseAutoClose() {
    this.clearAutoClose();
    const progressBar = this.notification.querySelector('.cart-notification__progress-bar');
    if (progressBar) {
      progressBar.style.animationPlayState = 'paused';
    }
  }

  // Возобновить авто-закрытие (после ухода мыши)
  resumeAutoClose() {
    const progressBar = this.notification.querySelector('.cart-notification__progress-bar');
    if (progressBar && this.notification.classList.contains('active')) {
      progressBar.style.animationPlayState = 'running';
      this.startAutoClose();
    }
  }
}

customElements.define('cart-notification', CartNotification);
